import { useSelector, useDispatch } from 'react-redux';
import { Modal } from 'antd';
import { isMobile } from '@zorba-shared/client/Services/clientService';
import { setModalState } from '../../../../../../reducers/Modal/actions';
import { MODAL_ESTIMATED_PROCEEDS } from '../../../../../../reducers/Modal/types';
import { ZorbaButton } from '../../../../../../components/forms';

import './index.scss';

export const EstimatedProceedsModal = () => {
  const { isEstimatedProceedsModalOpen } = useSelector(
    ({ ModalReducer }) => ModalReducer,
  );
  const dispatch = useDispatch();
  const handleCloseModal = async () => {
    dispatch(setModalState(MODAL_ESTIMATED_PROCEEDS, false));
  };

  const videoSrc =
    'https://www.youtube.com/embed/0nvxGYi-sI0?si=NeWXerRV_AKw08rA__&cc_load_policy=1&cc_lang_pref=en';

  return (
    <Modal
      open={isEstimatedProceedsModalOpen}
      footer={null}
      className="estimated-proceeds-training-modal"
      destroyOnClose
      centered={!isMobile()}
      width={!isMobile() ? 740 : ''}
      style={isMobile() ? { top: 200 } : {}}
      onCancel={handleCloseModal}
    >
      <div className="video-responsive">
        <div className="title-container">
          <span className="title">{`Introducing: Zorba’s SecondCheck Program`}</span>
          <span className="description">
            {`Watch this 60-second video to see how top-performing investors are maximizing their assignment fees in 2025 with Zorba:`}
          </span>
        </div>
        <iframe
          width={!isMobile() ? '640' : ''}
          height={!isMobile() ? '360' : ''}
          src={videoSrc}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
      </div>
      <div className="buttons-container">
        <ZorbaButton fullWidth={false} onClick={handleCloseModal}>
          Close
        </ZorbaButton>
      </div>
    </Modal>
  );
};
